var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 13.5 6 C 9.3754991 6 6 9.3754991 6 13.5 L 6 34.5 C 6 38.624501 9.3754991 42 13.5 42 L 34.5 42 C 38.624501 42 42 38.624501 42 34.5 L 42 13.5 C 42 9.3754991 38.624501 6 34.5 6 L 13.5 6 z M 13.5 9 L 34.5 9 C 37.003499 9 39 10.996501 39 13.5 L 39 18 L 30.599609 18 C 28.950631 16.186543 26.631199 15 24 15 C 21.368801 15 19.049369 16.186543 17.400391 18 L 9 18 L 9 13.5 C 9 10.996501 10.996501 9 13.5 9 z M 31.5 12 A 1.50015 1.50015 0 1 0 31.5 15 L 34.5 15 A 1.50015 1.50015 0 1 0 34.5 12 L 31.5 12 z M 24 18 C 27.331479 18 30 20.668523 30 24 C 30 27.331477 27.331479 30 24 30 C 20.668521 30 18 27.331477 18 24 C 18 20.668523 20.668521 18 24 18 z M 9 21 L 15.607422 21 C 15.265966 21.948081 15 22.937567 15 24 C 15 28.952794 19.047202 33 24 33 C 28.952798 33 33 28.952794 33 24 C 33 22.937567 32.734034 21.948081 32.392578 21 L 39 21 L 39 34.5 C 39 37.003499 37.003499 39 34.5 39 L 13.5 39 C 10.996501 39 9 37.003499 9 34.5 L 9 21 z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e9fbdc283acb6154903fb93f2f710c2e.svg";
export { ForwardRef as ReactComponent };